import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { acceptAgreements, getAgreements } from 'api/agreement/agreementApi';
import type { RootState } from 'store';
import { setAgreementDataResult, setIsApproved } from 'store/agreement/reducer';
import AgreementDialog from './AgreementDialog';
import FullscreenProgress from 'containers/AppStartup/FullScreenProgress';
import { addMessage } from 'store/snackbar/reducer';
import {
  agreementsApproved,
  errorMessage,
} from 'containers/Snackbar/snackbarMessages';

const SignUserAgreementDialog = () => {
  const dispatch = useDispatch();
  const { isLoaded, isApproved, agreements } = useSelector(
    (state: RootState) => state.agreement,
  );
  const [agreementDialogOpen, setAgreementDialogOpen] = useState(false);

  useEffect(() => {
    const fetchAndStoreAgreements = async () => {
      try {
        const response = await getAgreements();
        dispatch(setAgreementDataResult(response.parsedBody?.data));
      } catch {
        console.warn('Error when fetching agreements.');
        dispatch(setAgreementDataResult());
      }
    };
    if (!isLoaded) {
      void fetchAndStoreAgreements();
    }
  }, [dispatch, isLoaded]);

  const onApproval = async () => {
    try {
      await acceptAgreements({ documents: agreements?.map((a) => a.id) ?? [] });
      dispatch(addMessage(agreementsApproved()));
    } catch {
      dispatch(
        addMessage(errorMessage('An error occured when approving agreements')),
      );
    }

    setAgreementDialogOpen(false);
    dispatch(setIsApproved());
  };

  useEffect(() => {
    if (isLoaded && !isApproved) {
      setAgreementDialogOpen(true);
    }
  }, [isLoaded, isApproved]);

  if (!isLoaded) {
    return <FullscreenProgress isVisible />;
  }

  return <AgreementDialog open={agreementDialogOpen} onApproval={onApproval} />;
};

export default SignUserAgreementDialog;
